import React from 'react'

import { View, XStack, YStack } from 'tamagui'

import { Text } from '@newComponents/Text'

import { HomeScreenEventsCard } from '../HomeScreenEventsCard'
import { HomeScreenPresentationsCard } from '../HomeScreenPresentationsCard'
import { HomeScreenGuildNetworksCard } from '../HomeScreenGuildNetworksCard'

import { MarkerText } from './styles'
import { UnauthenticatedHomeScreen_query$data } from './__generated__/UnauthenticatedHomeScreen_query.graphql'

export function EverythingYouNeedSection({
  data,
}: {
  data: UnauthenticatedHomeScreen_query$data
}) {
  return (
    <YStack gap='$20' width='100%'>
      <YStack alignItems='center'>
        <View marginTop={150}>
          <MarkerText
            size='$9'
            $gtXs={{ size: '$10' }}
            $gtSm={{ size: '$11' }}
            textAlign='center'
          >
            EVERYTHING YOU NEED
          </MarkerText>
        </View>
        <Text
          size='$7'
          $gtXs={{ size: '$8' }}
          fontWeight='$6'
          textAlign='center'
        >
          to scale to new heights
        </Text>
      </YStack>

      <YStack gap='$9'>
        {/* Mobile/Tablet: stacked cards */}
        <YStack gap='$9' $gtMd={{ display: 'none' }}>
          <HomeScreenEventsCard query={data} />
          <HomeScreenPresentationsCard query={data} />
        </YStack>

        {/* Desktop: side by side */}
        <XStack gap='$9' display='none' $gtMd={{ display: 'flex' }}>
          <YStack flex={3} style={{ flexBasis: '0%' }}>
            <HomeScreenEventsCard query={data} />
          </YStack>

          <YStack flex={2} style={{ flexBasis: '0%' }}>
            <HomeScreenPresentationsCard query={data} />
          </YStack>
        </XStack>

        <HomeScreenGuildNetworksCard />
      </YStack>
    </YStack>
  )
}
